module.exports = __webpack_public_path__ + "img/1_drag_drop_tutorial.50f405b0.gif";